export const GREEN = '#26A69A';
